import { DateTime } from '@ksyos/date-time';
import type { PatientTaskStatus, Profession } from '@common/enums';
import type { IPatientTaskCustomControlData } from '@common/interfaces';
import type { ModelConstructorParameter } from '../types/modelType';
import { OutpatientClinicEpisodeCategory } from './outpatientClinicEpisodeCategoryModel';
import { OutpatientClinicOrganization } from './outpatientClinicOrganizationModel';
import { OutpatientClinicPatient } from './outpatientClinicPatientModel';
import { OutpatientClinicPractitioner } from './outpatientClinicPractitionerModel';
import { OutpatientClinicTaskType } from './outpatientClinicTaskTypeModel';

export class OutpatientClinicTask {
    public creatorPractitioner: ModelConstructorParameter<typeof OutpatientClinicPractitioner>;
    public creatorOrganization: ModelConstructorParameter<typeof OutpatientClinicOrganization>;
    public customControlData: IPatientTaskCustomControlData | null;
    public dateCompleted: DateTime | null;
    public description: string | null;
    public episodeCategory: ModelConstructorParameter<typeof OutpatientClinicEpisodeCategory>;
    public expectedDateCompleted: DateTime;
    public id: string;
    public isFlexibleCarePath: boolean;
    public patient: ModelConstructorParameter<typeof OutpatientClinicPatient>;
    public type: ModelConstructorParameter<typeof OutpatientClinicTaskType>;
    public performerOrganization: ModelConstructorParameter<typeof OutpatientClinicOrganization>;
    public performerPractitioner: ModelConstructorParameter<typeof OutpatientClinicPractitioner> | null;
    public performerPractitionerProfession: Profession | null;
    public processId: string | null;
    public status: PatientTaskStatus;
    public updated_at: DateTime | null;

    constructor(options: OutpatientClinicTask) {
        this.creatorPractitioner = new OutpatientClinicPractitioner(options.creatorPractitioner);
        this.creatorOrganization = new OutpatientClinicOrganization(options.creatorOrganization);
        this.customControlData = options.customControlData;
        this.dateCompleted = options.dateCompleted ? DateTime.from(options.dateCompleted) : null;
        this.description = options.description;
        this.episodeCategory = new OutpatientClinicEpisodeCategory(options.episodeCategory);
        this.expectedDateCompleted = DateTime.from(options.expectedDateCompleted);
        this.id = options.id;
        this.isFlexibleCarePath = options.isFlexibleCarePath;
        this.patient = new OutpatientClinicPatient(options.patient);
        this.type = new OutpatientClinicTaskType(options.type);
        this.performerOrganization = new OutpatientClinicOrganization(options.performerOrganization);
        this.performerPractitioner = options.performerPractitioner
            ? new OutpatientClinicPractitioner(options.performerPractitioner)
            : null;
        this.performerPractitionerProfession = options.performerPractitionerProfession;
        this.processId = options.processId;
        this.status = options.status;
        this.updated_at = options.updated_at ? DateTime.from(options.updated_at) : null;
    }
}
